<div class="container--title {{injection.content}}">
    <section class="{{ injection.icon }}">
        <so-icon [icon]="icon" [svg]="svg" [size]="iconScale" />
    </section>

    <h1 [style]="'margin-left: ' + iconSpace + 'px'" class="title-{{weight}} title-{{size}} {{injection.label}}">{{text}}</h1>
</div>
